import { FC, PropsWithChildren } from 'react';
import { AuthProvider } from 'react-oidc-context';

import { Auth } from '@inflo/lib/auth';

export const Provider: FC<PropsWithChildren> = ({ children }) => (
  <AuthProvider userManager={Auth.infloUserManager}>{children}</AuthProvider>
);
